import React, { Component } from "react";
import { Link } from "react-router-dom";

class Resume extends Component {
  render() {
    return (
      <div>
        <article class="post">
          <header>
            <div class="title">
              <h2>
                <a href="single.html">Resume</a>
              </h2>
            </div>
          </header>
          <h3>Summary</h3>
          <p>
            Versatile front-end developer with strong experience designing,
            developing, and maintaining JS with React+Redux, C++, and Java-based
            applications. Specializes in React and single page web applications.
          </p>
          <br />
          <h3>Technology Skills</h3>
          <div class="row">
            <div class="threecolumn">
              <h4>Very Comfortable With:</h4>
              <ul>
                <li>React / JSX</li>
                <li>HTML/CSS/JS ES9</li>
                <li>Formal Java Training</li>
                <li>C/C++ Programming in UNIX</li>
                <li>Source Control (Git)</li>
                <li>Create-React-App</li>
                <li>Webpack / Babel</li>
                <li>Google Firebase</li>
              </ul>
            </div>
            <div class="threecolumn">
              <br />
              <ul>
                <li>Continuous Integration Git Implementations</li>

                <li>NoSQL Databases (Firebase / MongoDB)</li>
                <li>SQL Databases (SQL Server & MySQL)</li>
                <li>ESLint Code Linting</li>
                <li>Prettier Code Format</li>
              </ul>
            </div>
            <div class="threecolumn">
              <h4>Experience With:</h4>

              <ul>
                <li>Agile Development</li>
                <li>Redux Integration</li>
                <li>Jest Testing</li>
                <li>Enzyme Test Utility</li>
                <li>RESTful APIs</li>
                <li>Adobe Photoshop</li>
                <li>InVISION Modeling</li>
                <li>Mobile Compatibility</li>
              </ul>
            </div>
          </div>
          <h3>Work Experience</h3>

          <p class="p1">
            <span class="s1">
              <strong>Ensign Consultants,</strong>
              <em>
                {" "}
                Plano, Texas
                <br />
                Lead Developer / Designer &amp; Founder, Fall 2017 - Present
              </em>
            </span>
          </p>
          <ul>
            <li class="p1">
              <span class="s1">
                In 2017, I started Ensign Consultants, a consulting company
                focused on Website Development, Custom Web Application
                Development, and Digital Marketing Services. As of Jan. 1 2019,
                My team and I have launced 12 Small Business Websites, and 2
                major web applications.
              </span>
            </li>
          </ul>

          <p class="p1">
            <span class="s1">
              <strong>USAA (United Services Automobile Association),</strong>
              <em>
                {" "}
                Plano, Texas
                <br />
                Software Developer &amp; Integrator III, Platform Infrastructure
                Intern, May 2018 - August 2018
              </em>
            </span>
          </p>
          <ul>
            <li class="p1">
              <span class="s1">
                Full-stack React web development with code I wrote being pushed
                to corporate production. Worked on a 7 person Agile team
                including other Interns and Full-Time developers to produce a
                major React web app from the ground up.
              </span>
            </li>
          </ul>
          <p class="p1">
            <span class="s1">
              <strong>Thought Ensemble, </strong>
              <em>
                Plano, Texas
                <br />
                Web Development Intern, November 2016
              </em>
            </span>
          </p>
          <ul>
            <li class="p1">
              <span class="s1">
                Developed front-end scripts for the corporate website including
                custom JavaScript elements
              </span>
            </li>
          </ul>
          <p class="p2">
            <span class="s1">
              <strong>Stream Energy &amp; Gas Ltd.,</strong>{" "}
              <em>
                Dallas, Texas
                <br />
              </em>
            </span>
            <span class="s1">
              <em>Information Technology Intern, July 2016 - August 2016</em>
            </span>
          </p>
          <ul>
            <li class="p2">
              <span class="s1">
                Created high-level business systems diagrams &amp; presentations
                to describe technical infrastructure to a non-technical audience
              </span>
            </li>
            <li>
              <span class="s1">
                Updated Microsoft SharePoint infrastructure for BA, QA, IT, and
                executive groups
              </span>
            </li>
            <li>
              <span class="s1">
                Completed rework of C# enterprise Sharepoint workflows
              </span>
            </li>
          </ul>
          <p class="p2">
            <span class="s1">
              <strong>
                Orthofix, Inc.
                <em>, </em>
              </strong>
              <em>
                Lewisville, Texas
                <br />
              </em>
            </span>
            <span class="s1">
              <em>
                Global Information Technology, Commercial Systems Intern, June
                2015 through January 2016
              </em>
            </span>
          </p>
          <ul>
            <li class="p2">
              <span class="s1">
                Developed sales applications for Apple iPhone and Apple Watch
                using Objective-C &amp; Swift
              </span>
            </li>
            <li class="p2">
              <span class="s1">
                Integrated sales applications with Oracle financial services for
                real-time updates
              </span>
            </li>
          </ul>
          <h3>Technology Skills</h3>

          <div class="row">
            <div class="twocolumn">
              <h4>Education</h4>
              <strong>University of Texas at Dallas, </strong>
              <em>Dallas, Texas</em>
              <br />
              B.S. Computer Science, anticipated May 2021
              <br />
              <br />
              <strong>Plano Academy High School, </strong>
              <em>Plano, Texas</em>
              <br />
              GPA 3.97/4.00 (student rank 5 out of 102)
              <br />
              <br />
              <strong>Work experience references available upon request</strong>
              <br />
              <br />
            </div>
            <div class="twocolumn">
              <h4>Organizations &amp; Volunteering</h4>
              <strong>National Honor Society, Plano Academy </strong>
              <br />
              <em>President 2013 &ndash; 2014</em>
              <br />
              <br />
              <strong>School Advisory Board, Plano Academy</strong>
              <br />
              <em>Class Representative 2013 - 2016</em>
              <br />
              <br />
              <strong>American Cancer Society, Relay for Life</strong>
              <br />
              <em>Team Captain 2013 - 2016</em>
              <br />
              Raised over $1,250 for cancer research
            </div>
          </div>

          <footer>
            <ul class="actions">
              <li>
                <a
                  href="https://firebasestorage.googleapis.com/v0/b/ryan-pearlman-personal.appspot.com/o/Resume%20August%202018.pdf?alt=media&token=9f747996-5014-43b0-ac68-1180ca5c1673"
                  class="button large"
                  target="_blank"
                  style={{ marginLeft: "120%" }}
                >
                  Download PDF Copy
                </a>
              </li>
            </ul>
          </footer>
        </article>
      </div>
    );
  }
}

export default Resume;



// WEBPACK FOOTER //
// ./src/components/Resume.js